import React from 'react';
import { Navigate } from 'react-router-dom';

// Lazy-loaded authenticated pages
const Account = React.lazy(() => import('../pages/Account'));
const Dashboard = React.lazy(() => import('../pages/Dashboard'));
const PaymentSuccess = React.lazy(() => import('../pages/PaymentSuccess'));
const ReportsPage = React.lazy(() => import('../pages/ReportsPage'));
const AdvertiserAuth = React.lazy(() => import('../pages/AdvertiserAuth'));
const AdvertiserDashboard = React.lazy(() => import('../pages/AdvertiserDashboard'));

const authRoutes = (user) => [
  { path: '/account', element: <Account /> },
  { path: '/reports', element: <ReportsPage /> },
  { path: '/advertiser/auth', element: <AdvertiserAuth /> },
  { path: '/advertiser/dashboard', element: <AdvertiserDashboard /> },
  { path: '/ads', element: <AdvertiserDashboard /> },
  { path: '/dashboard', element: user ? <Dashboard /> : <Navigate to="/login" /> },
  { path: '/payment-success', element: <PaymentSuccess /> },
];

export default authRoutes;
